// @ts-nocheck



import type RequestsController from '../requests';
import type { WialonApiSection } from '../requests';

export class Unit {
  controller: WialonApiSection;

  constructor(controller: RequestsController) {
    this.controller = controller.getApiSection('unit');
  }

  /**
   * Значения датчиков из последнего сообщения
   */
  async calcLastMessage(params)







  {
    return await this.controller.fetch('calc_last_message', params);
  }
}
